
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'CouponList',

  data() {
    return {
      couponError: null,
    };
  },

  computed: {
    ...mapState(['order', 'orderId', 'usePoints', 'couponCode']),
  },

  methods: {
    ...mapMutations(['setOrder']),
    ...mapActions(['togglePoints']),
    deleteCoupon(coupon) {
      this.$bolev
        .deleteCoupon({
          couponId: coupon.id,
          orderId: this.orderId,
        })
        .then((res) => {
          if (res.data) {
            // TODO: Is message being used?
            this.message = null;
            if (!this.usePoints) {
              this.setOrder(res.data);
            } else {
              this.togglePoints(false);
            }
          }
        })
        .catch(() => {
          // TODO: Is message being used?
          // this.message = this.$t('global.error');
          this.couponError = this.$t('global.error');
        });
    },
  },
};
